import { IconChevronsLeft, IconChevronsRight } from "@/assets/icons";
import { black, blue, text } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { isNumber } from "@/utils/number";
import { Pagination as MuiPagination, PaginationItem, Stack, styled } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

type Props = {
  totalPage?: number;
  count?: number;
};

export const NewPagination: FC<Props> = ({ totalPage }) => {
  const { pathname, search } = useLocation();

  const query = new URLSearchParams(location.search);
  const page = parseInt(query.get("page") || "1");

  const [displayTotalPage, setDisplayTotalPage] = useState<number>(1);

  useEffect(() => {
    if (isNumber(totalPage)) {
      setDisplayTotalPage(totalPage > 0 ? totalPage : 1);
    }
  }, [totalPage]);

  return (
    <Stack direction="row" alignItems="center" gap={2.5}>
      <StyledPagination
        page={Number.isNaN(page) ? 1 : page}
        count={displayTotalPage}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        renderItem={(item) => {
          const searchParams = new URLSearchParams(search);
          searchParams.set("page", item.page?.toString() ?? "1");

          // if (["page", "end-ellipsis", "start-ellipsis"].includes(item.type)) return null;

          return (
            <PaginationItem
              component={Link}
              to={{ pathname, search: searchParams.toString() }}
              slots={{ first: IconChevronsLeft, last: IconChevronsRight }}
              {...item}
            />
          );
        }}
      />
    </Stack>
  );
};

const StyledPagination = styled(MuiPagination)(() => ({
  "& .MuiPaginationItem-root": {
    border: "1px solid #CACDCD",
    borderRadius: 8,
    minWidth: 40,
    height: 40,
    ...typography.body14Semi,
    color: `${black[70]}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
  },
  "& .MuiPaginationItem-root.Mui-selected": {
    backgroundColor: `${blue[80]}`,
    color: `${text.white}`,
    border: "none",
    "&:hover": {
      backgroundColor: `${blue[80]}`,
    },
  },
  "& .MuiPaginationItem-ellipsis": {
    border: "1px solid transparent",
    minWidth: 40,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    fontWeight: 500,
    color: `${black[70]}`,
  },
  "& .MuiPaginationItem-root.Mui-disabled": {
    minWidth: 40,
    height: 40,
    border: "1px solid transparent",
    backgroundColor: `${black[99]}`,
    color: `${black[70]}`,
    pointerEvents: "none",
  },
}));
